import { useSuspenseQuery } from '@tanstack/react-query';
import useApi from '../useApi';
import type { RfSubscriptionStatus } from './subscriptionService';
import { SUBSCRIPTION_QUERY_KEYS } from './keys';

type UseRfSubscriptionStatusParams = {
  isAuthenticated: boolean;
  isRemembered: boolean;
  assetId?: string;
};

const DEFAULT_RF_SUBSCRIPTION_STATUS: RfSubscriptionStatus = {
  hasRfSubscription: false,
  rfRedownloadEligible: false,
};

const useRfSubscriptionStatus = ({
  isAuthenticated,
  isRemembered,
  assetId,
}: UseRfSubscriptionStatusParams) => {
  const { subscriptionService } = useApi();

  const fetchRfSubscriptionStatus = async (): Promise<RfSubscriptionStatus> => {
    if (!isAuthenticated && !isRemembered)
      return DEFAULT_RF_SUBSCRIPTION_STATUS;
    return await subscriptionService.getRfSubscriptionStatus(assetId);
  };

  const query = useSuspenseQuery<RfSubscriptionStatus>({
    queryKey: SUBSCRIPTION_QUERY_KEYS.rfSubscriptionStatus(assetId),
    queryFn: fetchRfSubscriptionStatus,
  });
  return { ...query, response: query.data };
};

export default useRfSubscriptionStatus;
